// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brands_mobile_bNQ8P{background-color:var(--cp-gray-9)}.v-application .v-main{min-height:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brands_mobile": "brands_mobile_bNQ8P"
};
module.exports = ___CSS_LOADER_EXPORT___;
